import { coSellMsftApi } from '../../tackleApiClient';
import {
  getReferral_Response,
  getReferralEvents_Response,
  getReferralListByCrmId_Response,
} from './schemas';

/** Get referral events by id */
export async function getReferralEvents({ tackleId }: { tackleId: string }) {
  const response = await coSellMsftApi
    .get(`api/referrals/${tackleId}/events`)
    .json();
  return getReferralEvents_Response.parse(response);
}

/**
 *  Get a referral by id
 */
export async function getReferralByTackleId({
  tackleId,
}: {
  tackleId: string;
}) {
  const response = await coSellMsftApi.get(`api/referrals/${tackleId}`).json();
  return getReferral_Response.parse(response);
}

/** Get list of referrals by crmId */
export async function getReferralsByCrmId({ crmId }: { crmId: string }) {
  const response = await coSellMsftApi
    .get(`api/referrals?crmId=${crmId}`)
    .json();
  return getReferralListByCrmId_Response.parse(response);
}
